import { render, staticRenderFns } from "./wxPopupComponent.vue?vue&type=template&id=b7223578&scoped=true&"
import script from "./wxPopupComponent.vue?vue&type=script&lang=js&"
export * from "./wxPopupComponent.vue?vue&type=script&lang=js&"
import style0 from "./wxPopupComponent.vue?vue&type=style&index=0&id=b7223578&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7223578",
  null
  
)

export default component.exports